var map = {
	"./Base": 726,
	"./Base/": 726,
	"./Base/index": 726,
	"./Base/index.js": 726,
	"./Base/style": 177,
	"./Base/style.js": 177,
	"./Clutch": 427,
	"./Clutch/": 427,
	"./Clutch/index": 427,
	"./Clutch/index.js": 427,
	"./Clutch/renderComponent": 1634,
	"./Clutch/renderComponent.js": 1634,
	"./Clutch/style": 1291,
	"./Clutch/style.js": 1291,
	"./NewUi": 1012,
	"./NewUi/": 1012,
	"./NewUi/index": 1012,
	"./NewUi/index.js": 1012,
	"./NewUi/style": 1292,
	"./NewUi/style.js": 1292,
	"./OldUi": 1013,
	"./OldUi/": 1013,
	"./OldUi/index": 1013,
	"./OldUi/index.js": 1013,
	"./OldUi/renderComponent": 1635,
	"./OldUi/renderComponent.js": 1635,
	"./OldUi/style": 1293,
	"./OldUi/style.js": 1293,
	"./SpireonNew": 1014,
	"./SpireonNew/": 1014,
	"./SpireonNew/index": 1014,
	"./SpireonNew/index.js": 1014,
	"./SpireonNew/renderComponent": 1636,
	"./SpireonNew/renderComponent.js": 1636,
	"./SpireonNew/style": 1294,
	"./SpireonNew/style.js": 1294,
	"./SpireonOld": 1015,
	"./SpireonOld/": 1015,
	"./SpireonOld/index": 1015,
	"./SpireonOld/index.js": 1015,
	"./SpireonOld/renderComponent": 1637,
	"./SpireonOld/renderComponent.js": 1637,
	"./SpireonOld/style": 1295,
	"./SpireonOld/style.js": 1295
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;